<template>

    <ion-row>
        <ion-col size="12" size-sm="8" offset-sm="2" size-md="8" offset-md="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3">
            <div class="padding">
                <div class="text-center">
                    <h1 class="mb-10">WIEDZA</h1>
                    <p class="pd-0 mb-20">Twój wynik</p>

                    <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>
                    <transition name="fade">
                        <div v-if="!loading">
                            <div class="score" ref="score">
                                <div class="score-content" ref="scoreContent">
                                    <div class="svg-wrapper svg-inline svg-rwd svg-animate">
                                        <svg-padlock-steps ref="padlockSteps"
                                                           pause="false"
                                                           id="Padlock"
                                                           :totalQuestions="score.total"
                                                           :passedQuestions="score.passed"
                                                           :showQuestionsLabel="true">
                                        </svg-padlock-steps>
                                    </div>
                                </div>
                            </div>

                            <div class="entry" ref="entry" v-html="info"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </ion-col>
    </ion-row>

</template>

<script>
    import SvgPadlockSteps from "../../../components/svgplus/SvgPadlockSteps";
    import KnowledgeServices from '../../../services/KnowledgeServices';

    export default {
        name: 'Score',
        components: {
            SvgPadlockSteps
        },
        data: () => ({
            loading: true,
            errors: [],
            score: {
                passed: 0,
                total: 4
            },
            info: ''
        }),
        methods: {
            playAnimate(){
                setTimeout(() => {
                    this.$refs.padlockSteps.playAnimate();
                }, 500)
            },
            getData(){
                this.loading = true;
                KnowledgeServices.getScores()
                    .then((response) => {
                        this.loading = false;
                        let _data = response.data.data;
                        if (_data.score) {
                            this.score = _data.score;
                        }
                        this.info = _data.info;
                        //
                        this.playAnimate();
                    })
                    .catch((e) => {
                        this.errors.push(e.toString())
                    })
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>
